import qs from 'query-string';

const redirectToPlanListing = (data) => {
  let queryParams;

  switch (data.category) {
  case 'auto': {
    queryParams = {
      namePlan: data.namePlan,
      year: data.year,
      category: data.category,
      area: data.area,
      phoneNumber: data.phoneNumber,
      email: data.email,
      name: data.fullName
    };
    window.location.href = `${process.env.GATSBY_CORE_URL}plans?${qs.stringify(queryParams)}`;
    break;
  }
  case 'health': {
    const members = {
      mySelf: {
        age: data.age,
        gender: data.gender
      }
    };
    queryParams = new URLSearchParams({
      gender: data.gender,
      age: data.age,
      phoneNumber: data.phoneNumber,
      email: data.email ?? '',
      fullName: data.fullName ?? '',
      category: 'health',
      step: '1',
      selfChecked: 'true',
      members: JSON.stringify(members)
    });
    window.location.href = `${process.env.GATSBY_CORE_URL}search?${queryParams.toString()}`;
    break;
  }
  case 'life': {
    queryParams = new URLSearchParams({
      gender: data.gender,
      age: data.age,
      phoneNumber: data.phoneNumber,
      email: data.email ?? '',
      fullName: data.fullName ?? '',
      category: 'life',
      step: '1',
      relation: 'Saya Sendiri'
    });
    window.location.href = `${process.env.GATSBY_CORE_URL}search?${queryParams.toString()}`;
    break;
  }
  case 'moto': {
    queryParams = new URLSearchParams({
      category: 'moto'
    });
    window.location.href = `${process.env.GATSBY_CORE_URL}search?${queryParams.toString()}`;
    break;
  }
  default: {
    throw new Error('Form category doesn\'t exist!');
  }
  }
};

export default redirectToPlanListing;
